import {
  type GetPrayerStreamErrorResponseDtoStatus,
  type GetPrayerStreamSuccessResponseDtoStatus,
} from '@ccm-innovation/member-center-bff-sdk-axios';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type GetPrayerStreamUserRegistrationResponseStatus =
  | GetPrayerStreamErrorResponseDtoStatus
  | GetPrayerStreamSuccessResponseDtoStatus;

export type GetPrayerStreamUserRegistrationState = {
  pending: boolean;
  status: GetPrayerStreamUserRegistrationResponseStatus | null;
};

const initialState: GetPrayerStreamUserRegistrationState = {
  pending: false,
  status: null,
};

export const getPrayerStreamUserRegistrationSlice = createSlice({
  initialState,
  name: 'getPrayerStreamUserRegistration',
  reducers: {
    getPrayerStreamUserRegistrationFailed: (
      state,
      action: PayloadAction<GetPrayerStreamUserRegistrationResponseStatus>,
    ) => {
      state.pending = false;
      state.status = action.payload;
    },
    getPrayerStreamUserRegistrationRequested: () => {
      /* handled by saga */
    },
    getPrayerStreamUserRegistrationReset: () => {
      return initialState;
    },
    getPrayerStreamUserRegistrationStarted: (state) => {
      state.pending = true;
    },
    getPrayerStreamUserRegistrationSucceeded: (
      state,
      action: PayloadAction<GetPrayerStreamUserRegistrationResponseStatus>,
    ) => {
      state.pending = false;
      state.status = action.payload;
    },
  },
});
